export const SANKEY_CHART_STYLE = {
  nodeWidth: 20,
  nodeLabels: {
    weight: 400,
    size: 12,
    textBorderWidth: 3,
  },
  edgeLabels: {
    weight: 400,
    size: 12,
    textBorderWidth: 3,
  },
  padding: {
    percent: 0.05,
    minPadding: 24,
  },
  edgeColor: {
    // eslint-disable-next-line no-color-literals
    gray: "#81898e", // --mb-base-color-orion-50
  },
};
